const REGISTRATION_PROMPT_COPY = {
  loginAction: 'Login',
  signUpAction: 'Sign Up',
};

export default REGISTRATION_PROMPT_COPY;
